import { notification } from 'antd';

export const handleError = (err: any) => {

  const isNetworkError = err?.response?.data;

  if (!isNetworkError) {
    console.error(err);
    notification.error({message: 'General error'});
    return;
  }

  const { statusCode, message } = err?.response?.data;
  if (statusCode === 409) {
    // project exists
    notification.error({ message });
  } else {
    notification.error({ message });
  }
};
